"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useProductInfo = useProductInfo;
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
function useProductInfo(productCode) {
    const { language } = (0, _i18n.useLanguage)();
    const { tenant } = (0, _environment.useEnvironment)();
    const params = (0, _react.useMemo)(()=>({
            lang: language
        }), [
        language
    ]);
    const { data } = (0, _staticApiClientReact.useGetTenantProduct)(tenant, productCode, params, {
        request: {
            validateStatus: (status)=>status < 500
        }
    });
    var _data_imageUrl;
    return (_data_imageUrl = data === null || data === void 0 ? void 0 : data.imageUrl) !== null && _data_imageUrl !== void 0 ? _data_imageUrl : 'noImage';
}
